// extracted by mini-css-extract-plugin
export default {"problemList":"styles_problemList__dKitV"};